export default __webpack_public_path__ + "static/media/pattern-herringBone-90-2.3d1b1208.jpg";